import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import HighlightsTable from "./components/HighlightsTable";

const ProductionSettings = () => {
  return (
    <>
      <TeamHeading />
      <PageHeading>Settings</PageHeading>
      <HighlightsTable />
    </>
  );
};

export default ProductionSettings;
